module.exports = __webpack_public_path__ + "static/media/call_green.c311bc96.png";